import { render } from "./BookingHighstakeImport.vue?vue&type=template&id=5a35b59c"
import script from "./BookingHighstakeImport.vue?vue&type=script&lang=js"
export * from "./BookingHighstakeImport.vue?vue&type=script&lang=js"
script.render = render

export default script